import { ConfigProvider as GenesysConfigProvider } from "@commonlibs";
import { ReactNode, useMemo } from "react";
import useTranslate from "ui/locale/hooks/useTranslate";
import config from "./config";
import { GlobalStyles } from "./theme/GlobalStyles/GlobalStyles";
import { useTranslation } from "react-i18next";
import { IAuthBootstrapper } from "commonlibs/shared-services/auth/domain/IAuthBootstraper";
import { CognitoAuthBootstrapper } from "commonlibs/shared-services/auth/cognito/CognitoAuthBootstrapper";
import { default as adminConfig } from "common/config/config";

export interface ConfigProviderProps {
    children?: ReactNode;
}

const ConfigProvider = ({ children }: ConfigProviderProps): JSX.Element => {
    const translate = useTranslate("error");
    const { i18n } = useTranslation();
    const authBootstrapper: IAuthBootstrapper = new CognitoAuthBootstrapper();

    authBootstrapper.initialize(adminConfig.cognito.poolId, adminConfig.cognito.appClientId);

    const finalConfig = useMemo(() => ({ ...config, translate, locale: i18n.language }), [translate, i18n]);

    return (
        <GenesysConfigProvider config={finalConfig}>
            <GlobalStyles />
            {children}
        </GenesysConfigProvider>
    );
};

export default ConfigProvider;
